import ModelFactory from 'business/models/ModelFactory';
import { CrystalSoakingDTO, SoakingClient, SoakingDTO } from 'business/models/Models';

export default class SoakingService {
  static myInstance: SoakingService = null;
  _soakingClient: SoakingClient;

  constructor() {
    this._soakingClient = ModelFactory(SoakingClient, false, true);
  }

  static getInstance() {
    if (SoakingService.myInstance == null) {
      SoakingService.myInstance = new SoakingService();
    }

    return this.myInstance;
  }

  async getAllSoakingOfCurrentUser(): Promise<SoakingDTO[]> {
    return await this._soakingClient.getAllSoakingOfCurrentUser();
  }

  async addSoakings(soakings: SoakingDTO[]): Promise<SoakingDTO[]> {
    return await this._soakingClient.saveSoakings(soakings);
  }

  async deleteSoakings(soakingList: SoakingDTO[]) {
    await this._soakingClient.deleteSoaking(soakingList);
  }

  async assignSoakingToCrystals(crystalSoakingList: CrystalSoakingDTO[]) {
    await this._soakingClient.assignSoakingToCrystals(crystalSoakingList);
  }
  async getInUseSoakingsByIds(soakingIds: number[]): Promise<SoakingDTO[]> {
    return await this._soakingClient.getInUseSoakingsByIds(soakingIds);
  }
}
